/* eslint-env browser, node */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSelectedTitleValue, resetTitleFees } from '../../redux/modules/titlefees';
import { resetMobileHome } from '../../redux/modules/mobilehome';
import Dropdown from '../../components/Dropdown';
import floridaTitles from '../../modules/data/florida-titles';
import mcoTitles from '../../modules/data/mco-titles';
import osTitles from '../../modules/data/os-titles';
import precise from '../../modules/precise';
import { TITLES, VEHICLES } from '../../modules/constants';
import getPipeValue from '../../modules/getPipeValue';

class TitleDropDowns extends Component {
  constructor(props) {
    super(props);
    this.onFloridaTitleSelect = this.onFloridaTitleSelect.bind(this);
    this.onMCOTitleSelect = this.onMCOTitleSelect.bind(this);
    this.onOSTitleSelect = this.onOSTitleSelect.bind(this);
  }

  resetMobileHomes(selectedTitle) {
    const { selectedVehicleType } = this.props;
    const vehicleIsMobile = selectedVehicleType && selectedVehicleType === VEHICLES.MOBILE_HOMES;
    const titleIsMobile = selectedTitle && selectedTitle.search('MOBILE HOME') > -1;

    if (!vehicleIsMobile && !titleIsMobile) {
      this.props.resetMobileHome();
    }
  }

  onFloridaTitleSelect(event) {
    this.props.resetTitleFees();
    const selectedValue = event.target.value;
    this.resetMobileHomes(selectedValue);

    const { selectedVehicleValue } = this.props;
    const myTChoice = selectedValue;
    let BFfee = Number(this.props.BFfee);

    const r16 = Number(getPipeValue(selectedVehicleValue, 'r16'));

    if (r16 === 2) {
      alert('No title required for Vehicle Type shown in registration section');
    }

    if (r16 !== 2 && selectedValue !== '') {
      const aryTResults = myTChoice.split('|');
      const t0 = aryTResults[0]; // Type Label
      const t1 = Number(aryTResults[1]); // Fees
      const t2 = Number(aryTResults[2]); // MV,VS, HS, type etc
      const t3 = isNaN(parseInt(aryTResults[3], 10)) ? aryTResults[3] : Number(aryTResults[3]); // Lien Only/Lien Add set fees code 1 = vehicles; 5 = vessels; 7 = ohv ADD ?
      const t4 = (aryTResults[4]); // Disable fast title for lien only & certificate of destruction & certificate of repossession; 2 = not allowed;

      // As much as I am against this, this m value is the placeholder field
      // john used in the PDF. Until I am able to give this calculation a true (and badly-needed)
      // refactor, I am going to use this placeholder in John's way for now. After all
      // of the functional tests are setup, then it will be safe to refactor this and remove
      // John's placeholder values. ¯\_(ツ)_/¯
      let m = 0; // this is the 'middletitle' placeholder from the PDF.

      if (t2 === 7 && t3 === 7) {
        BFfee *= 3;
      } // OHV duplicate title, title and decal all (3) require branch fee

      if (t2 === 7 && t3 !== 7) {
        BFfee *= 2;
      } // OHV title and title decal both require branch fee

      if (t1 === 0) {
        m = 1 * t1;
      }

      if (t1 !== 150.50 || t1 !== 11.25 || t1 !== 108.50) {
        m = (1 * t1) + BFfee;
      }

      if (t1 === 150.50 || t1 === 11.25 || t1 === 108.50) {
        m = (1 * t1) + (2 * BFfee);
      } // title fee(t1) + branch fee times 1or2 to force number (NOT FOR OHV)

      // t2 !== 8 is this needed?
      if (r16 !== t2 && r16 !== 0 && t2 !== 8) {
        alert('Registration vehicle type chosen above does not match this title type.\nPlease reset registration section or choose correct title type.');
      } else {
        // You are safe to update the reducer.
        // Set titleVariables so they are available to the different dropdowns. ¯\_(ツ)_/¯
        const titleVariables = {
          floridaTitle: true,
          mcoTitle: false,
          osTitle: false,
          disableLemon: true,
          t0,
          t1,
          t2,
          t3,
          t4,
        };
        const titleLabel = t0;
        this.props.setSelectedTitleValue(precise(m), selectedValue, titleVariables, titleLabel, TITLES.FLORIDA_TITLE);
      }
    }
  }

  onMCOTitleSelect(event) {
    this.props.resetTitleFees();
    const selectedValue = event.target.value;
    this.resetMobileHomes(selectedValue);

    const { selectedVehicleValue } = this.props;
    const myTChoice = selectedValue;
    let BFfee = Number(this.props.BFfee);

    const r16 = Number(getPipeValue(selectedVehicleValue, 'r16'));

    if (r16 === 2) {
      alert('No title required for above Vehicle Type');
    }

    if (r16 !== 2 && selectedValue !== '') {
      const aryTResults = myTChoice.split('|'); // separate out field and property strings at quotation marks
      const t0 = aryTResults[0];
      const t1 = Number(aryTResults[1]);
      const t2 = Number(aryTResults[2]);

      if (t2 === 7) {
        BFfee *= 2;
      } // OHV title and title decal both require branch fee

      // As much as I am against this, this m value is the placeholder field
      // john used in the PDF. Until I am able to give this calculation a true (and badly-needed)
      // refactor, I am going to use this placeholder in John's way for now. After all
      // of the functional tests are setup, then it will be safe to refactor this and remove
      // John's placeholder values. ¯\_(ツ)_/¯
      let m = 0; // this is the 'middletitle' placeholder from the PDF.

      if (t1 === 0) {
        m = 1 * t1;
      }

      if (t1 !== 0) {
        m = 1 * (t1 + BFfee);
      } // title fee(t1)+branch fee times 1 to force numeric

      if (r16 !== t2 && r16 !== 0) {
        alert('Registration vehicle type chosen above does not match this title type.\nPlease reset registration section or choose correct title type.');
      } else {
        // You are safe to update the reducer.
        // Set titleVariables so they are available to the different dropdowns. ¯\_(ツ)_/¯
        const titleVariables = {
          floridaTitle: false,
          mcoTitle: true,
          osTitle: false,
          disableLemon: false,
          t0,
          t1,
          t2,
          t3: null,
          t4: null,
        };
        const titleLabel = t0;
        this.props.setSelectedTitleValue(precise(m), selectedValue, titleVariables, titleLabel, TITLES.MCO_TITLE);
      }
    }
  }

  onOSTitleSelect(event) {
    this.props.resetTitleFees();
    const selectedValue = event.target.value;
    this.resetMobileHomes(selectedValue);

    const { selectedVehicleValue } = this.props;
    const myTChoice = selectedValue;
    let BFfee = Number(this.props.BFfee);

    const r16 = Number(getPipeValue(selectedVehicleValue, 'r16'));

    if (r16 === 2) {
      alert('No title required for above Vehicle Type');
    }

    if (r16 !== 2 && selectedValue !== '') {
      const aryTResults = myTChoice.split('|'); // separate out field & property strings at quotation marks
      const t0 = (aryTResults[0]);
      const t1 = Number(aryTResults[1]);
      const t2 = Number(aryTResults[2]);
      const t3 = Number(aryTResults[3]); // Lien Only / Lien Add set fees code 1 = vehicles; 5 = vessels (not for out-of-state issues)
      const t4 = Number(aryTResults[4]); // disable fast title for lien only & certificate of destruction & certificate of repossession; 2 = not allowed;

      // As much as I am against this, this m value is the placeholder field
      // john used in the PDF. Until I am able to give this calculation a true (and badly-needed)
      // refactor, I am going to use this placeholder in John's way for now. After all
      // of the functional tests are setup, then it will be safe to refactor this and remove
      // John's placeholder values. ¯\_(ツ)_/¯
      let m = 0; // this is the 'middletitle' placeholder from the PDF.

      if (t2 === 7) {
        BFfee *= 2;
      } // OHV title and decal both require branch fee

      if (t1 === 0) {
        m = 1 * t1;
      }

      if (t1 !== 0) {
        m = 1 * (t1 + BFfee);
      } // title fee(t1) + branch fee times 1 to force numeric

      if (r16 !== t2 && r16 !== 0) {
        alert('Registration vehicle type chosen above does not match this title type.\nPlease reset registration section or choose correct title type.');
      } else {
        // You are safe to update the reducer.
        // Set titleVariables so they are available to the different dropdowns. ¯\_(ツ)_/¯
        const titleVariables = {
          floridaTitle: false,
          mcoTitle: false,
          osTitle: true,
          disableLemon: true,
          t0,
          t1,
          t2,
          t3,
          t4,
        };
        const titleLabel = t0;
        this.props.setSelectedTitleValue(precise(m), selectedValue, titleVariables, titleLabel, TITLES.OOS_TITLE);
      }
    }
  }

  render() {
    const { selectedTitleValue, titleFee, titleLabel, titleType } = this.props;
    return (
      <div className="Box">

        <div className="Title-DropdownRow">

          <div className="Console">
            <span className="Console-vehicleType">{titleType ? titleType.split('/').pop() : ''}</span>
            <span className="Console-text" id="whichchosen">{titleLabel}</span>
          </div>

          <Dropdown
            initial={['Florida Title', '']}
            id="DynolistFLTitle"
            tooltip="Currently titled in Florida"
            options={floridaTitles}
            onChange={this.onFloridaTitleSelect}
            selectedValue={selectedTitleValue}
            className={`Dropdown TitleDropdown${titleType === TITLES.FLORIDA_TITLE ? ' Dropdown--active' : ''}`}
          />

          <Dropdown
            initial={['Manufacturer MCO', '']}
            id="DynolistMCOTitle"
            tooltip="Manufacturers Certificate of Origin for NEW Vehicle"
            options={mcoTitles}
            onChange={this.onMCOTitleSelect}
            selectedValue={selectedTitleValue}
            className={`Dropdown TitleDropdown${titleType === TITLES.MCO_TITLE ? ' Dropdown--active' : ''}`}
          />

          <Dropdown
            initial={['Out of State Title', '']}
            id="DynolistOSTitle"
            tooltip="Any Out-of-State (not Florida) - U.S. States and Territories"
            options={osTitles}
            onChange={this.onOSTitleSelect}
            selectedValue={selectedTitleValue}
            className={`Dropdown TitleDropdown${titleType === TITLES.OOS_TITLE ? ' Dropdown--active' : ''}`}
          />

        </div>

        <div className="Row">
          <input
            type="text"
            value={titleFee}
            readOnly
            className="Row-total"
            tabIndex="-1"
          />

          <b>Title Fee</b>

        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedTitleValue: state.titlefees.selectedTitleValue,
    selectedVehicleValue: state.registration.selectedVehicleValue,
    selectedVehicleType: state.registration.selectedVehicleType,
    titleFee: state.titlefees.titleFee,
    titleLabel: state.titlefees.titleLabel,
    titleType: state.titlefees.titleType,
    BFfee: state.registration.BFfee,
  };
};

export default connect(mapStateToProps, { setSelectedTitleValue, resetTitleFees, resetMobileHome })(TitleDropDowns);



// WEBPACK FOOTER //
// ./src/containers/titlefees/TitleDropdowns.js